import React, { useEffect, useRef, useState, useCallback } from "react";
import { BACKEND_URL } from "@/lib/api";

/**
 * Live event stream from FastAPI /api/ws.
 * Reconnects automatically with backoff.
 */
export function useLiveEvents(onEvent) {
  const wsRef = useRef(null);
  const backoff = useRef(1000);
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  const connect = useCallback(() => {
    const token = localStorage.getItem("cz_token");
    const wsUrl = BACKEND_URL.replace(/^http/, "ws") + "/api/ws" + (token ? `?token=${encodeURIComponent(token)}` : "");
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;
    ws.onopen = () => { backoff.current = 1000; };
    ws.onmessage = (ev) => {
      let payload;
      try { payload = JSON.parse(ev.data); } catch (_) { return; }
      try {
        cbRef.current && cbRef.current(payload);
      } catch (err) {
        console.warn("live event handler failed", payload?.event, err);
      }
    };
    ws.onclose = () => {
      setTimeout(connect, backoff.current);
      backoff.current = Math.min(backoff.current * 2, 15000);
    };
    ws.onerror = () => { try { ws.close(); } catch (_) {} };
  }, []);

  useEffect(() => {
    connect();
    return () => { try { wsRef.current?.close(); } catch (_) {} };
  }, [connect]);
}
